export function dispatchEvent(eventName: string) {
    if (typeof window === "undefined") {
        return;
    }
    window.dispatchEvent(new Event(eventName));
}
